var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DocumentType } from './sample.model';
import { ElementRef } from '@angular/core';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { WizardService } from 'app/orders/wizard/wizard.service';
import { FileService } from 'app/files/file.service';
import { DownloadService, isIE, isEdge } from 'app//files/download.service';
import { camelCase } from 'app/core/case-transform';
var WizardUseExamplesComponent = /** @class */ (function () {
    function WizardUseExamplesComponent(sample, _dialogService, _userSettingsService, _fileService, _downloadService, _wizardService) {
        this.sample = sample;
        this._dialogService = _dialogService;
        this._userSettingsService = _userSettingsService;
        this._fileService = _fileService;
        this._downloadService = _downloadService;
        this._wizardService = _wizardService;
        this.sampleWidth = 120;
        this.documentsTypes = [
            {
                key: DocumentType.Invoices,
                value: 'Invoices'
            }
        ];
        // Выбранный тип документа
        this.documentType = this.documentsTypes[0].key;
    }
    Object.defineProperty(WizardUseExamplesComponent.prototype, "processing", {
        get: function () {
            return this._processing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardUseExamplesComponent.prototype, "visibleRegion", {
        get: function () {
            return this._userSettingsService.serviceType === 'ic';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardUseExamplesComponent.prototype, "samplesElement", {
        get: function () {
            return this.samplesList.nativeElement;
        },
        enumerable: true,
        configurable: true
    });
    WizardUseExamplesComponent.prototype.ngOnInit = function () {
        this.orderSettings = Object.assign({}, this._userSettingsService.orderSettings);
        if (this.orderSettings.verificationType === 'Troubleshooting') {
            this.orderSettings.verificationType = 'UserVerification';
        }
        if (this._userSettingsService.serviceType === 'dc') {
            this.documentsTypes.push({
                key: DocumentType.ApplicationForms,
                value: 'Application Forms'
            }, {
                key: DocumentType.Contracts,
                value: 'Contracts'
            }, {
                key: DocumentType.Letters,
                value: 'Letters'
            });
            this.documentType = this.documentsTypes[1].key;
        }
    };
    WizardUseExamplesComponent.prototype.onSubmit = function (form) {
        return __awaiter(this, void 0, void 0, function () {
            var fileBlob, fileSource, inputFile, file, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.onHideError();
                        if (!form.valid) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this._processing = true;
                        return [4 /*yield*/, this._downloadService.download(this.sample.fileUrl)];
                    case 2:
                        fileBlob = _a.sent();
                        fileSource = isIE() || isEdge()
                            ? fileBlob
                            : new File([fileBlob], this.sample.fileName);
                        inputFile = {
                            name: this.sample.fileName,
                            size: this.sample.size,
                            extension: this.sample.extension,
                            source: fileSource
                        };
                        return [4 /*yield*/, this._fileService.upload(inputFile).toPromise()];
                    case 3:
                        file = _a.sent();
                        inputFile.id = file.id;
                        inputFile.token = file.token;
                        this._userSettingsService.orderSettings = Object.assign({}, this.orderSettings);
                        this._wizardService.files = [
                            Object.assign({}, inputFile, { progress: 100 })
                        ];
                        this._wizardService
                            .create({
                            export_format: this.orderSettings.exportFormat,
                            region: this.sample.region || this.orderSettings.region,
                            verification: this.orderSettings.verificationType,
                            document_type: this._userSettingsService.documentType,
                        }, this._userSettingsService.serviceType)
                            .subscribe(function () {
                            _this._wizardService.reset();
                            _this._dialogService.close();
                        }, function (error) { return _this._onError(error); });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this._onError(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WizardUseExamplesComponent.prototype.isSelectedType = function (type) {
        return type === this.documentType;
    };
    WizardUseExamplesComponent.prototype.isSelected = function (sample) {
        return sample === this.sample;
    };
    WizardUseExamplesComponent.prototype.canMoveNext = function () {
        return (this.samplesElement.scrollLeft <
            this.samplesElement.scrollWidth - this.samplesElement.clientWidth);
    };
    WizardUseExamplesComponent.prototype.canMovePrev = function () {
        return this.samplesElement.scrollLeft > 0;
    };
    WizardUseExamplesComponent.prototype.nextSample = function () {
        this.addScroll(this.samplesList, this.sampleWidth);
    };
    WizardUseExamplesComponent.prototype.prevSample = function () {
        this.addScroll(this.samplesList, -this.sampleWidth);
    };
    WizardUseExamplesComponent.prototype.onMouseWheel = function (delta) {
        this.addScroll(this.samplesList, -delta * 50);
    };
    WizardUseExamplesComponent.prototype.addScroll = function (elementRef, scroll) {
        var element = elementRef.nativeElement;
        element.scrollLeft += scroll;
    };
    WizardUseExamplesComponent.prototype.close = function () {
        this._dialogService.close();
    };
    WizardUseExamplesComponent.prototype.regionName = function (region) {
        switch (region) {
            case 'AU':
                return 'Australia';
            case 'CA':
                return 'Canada';
            case 'EU':
                return 'European Union';
            case 'US':
                return 'USA';
            default:
                return 'Unknown';
        }
    };
    WizardUseExamplesComponent.prototype.onHideError = function () {
        this.error = null;
        this.errorDescription = null;
    };
    WizardUseExamplesComponent.prototype._onError = function (response) {
        if (response.status === 400) {
            var responseJson = response.json();
            this.error = camelCase(responseJson.error);
            this.errorDescription = this._getErrorDescription(responseJson);
        }
        this._processing = false;
    };
    WizardUseExamplesComponent.prototype._getErrorDescription = function (responseJson) {
        var modelState = responseJson.modelState;
        if (!modelState) {
            return responseJson.errorDescription;
        }
        return Object.keys(modelState)
            .map(function (fieldName) { return modelState[fieldName].join('\n'); })
            .join('\n');
    };
    return WizardUseExamplesComponent;
}());
export { WizardUseExamplesComponent };
